import { mensexhealth } from './initial/flow';

const MenSexHealthFlows = { mensexhealth };

export default MenSexHealthFlows;
